import { createApi } from '@reduxjs/toolkit/query/react';
import * as searchGtm from 'tradera/apps/tradera/components/discover/helpers/search-gtm';
import { httpClientBaseQuery } from './utils/http-client-base-query';
import { touchWebClient } from 'tradera/utils/http';
import { toSearchString } from 'tradera/utils/url';

export enum SortBy {
    Relevance = 'Relevance',
    AddedOn = 'AddedOn'
}

type TouchwebSaveSearchRequest = {
    savedQueryName: string;
    categoryId?: number;
};

type TouchwebSaveSearchResponse = {
    id: number;
    message?: string;
};

export const touchwebSearchApi = createApi({
    reducerPath: 'touchwebSearchApi',
    baseQuery: httpClientBaseQuery({ client: touchWebClient }),
    endpoints: (builder) => ({
        saveSearch: builder.mutation<
            TouchwebSaveSearchResponse,
            TouchwebSaveSearchRequest
        >({
            query: (parameters) => {
                const payload = toSearchString(parameters, {
                    addQueryPrefix: false
                });
                return {
                    url: '/my/savedsearches/add',
                    method: 'POST',
                    body: payload,
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    }
                };
            },
            async onQueryStarted() {
                searchGtm.trackAction(
                    searchGtm.GA_EVENT_SAVE_SEARCH,
                    'Save POST Request'
                );
            }
        })
    })
});

export const { useSaveSearchMutation } = touchwebSearchApi;
